// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","display":"_1KAM","button":"_3oge"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Markdown/Markdown.scss
// module id = Kjfr
// module chunks = 0